import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Person"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-person',
    templateUrl: './icon-person.component.html',
    styleUrls: ['./icon-person.component.scss'],
    standalone: false
})
export class IconPersonComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
